import React from "react";
import "./Projects.css";

import JourEtNuitImage from "../assets/Jour-et-Nuit-Screenshot.png";
import SprinkerLubeImage from "../assets/sprinkler-lube.png";
import TrackCubedImage from "../assets/track_cubed_logo_optimized.png";

const projectData = [
  {
    title: "Track³",
    description:
      'Track³ (Track Cubed) is a cross-platform mobile application built with .NET MAUI that allows users to save and organize various digital items—such as links, images, songs, or documents—as "Cubed Items." Each item can be tagged, described, and easily searched for later. <br /> The application is powered by a secure ASP.NET Core Web API backend connected to an Azure SQL database, with user authentication handled by Microsoft Entra ID.',
    imageUrl: TrackCubedImage,
    imageAlt: "Track Cubed geometric cube logo",
    imageClassName: "project-image--contain",
    links: [
      {
        url: "https://github.com/curtism99/TrackCubed",
        text: "Source Code",
      },
    ],
  },
  {
    title: "Jour et Nuit (Day and Night)",
    description:
      'An Augmented Realty Experience Powered by <a href="https://developers.google.com/ar/discover/" target="_blank" rel="noopener noreferrer">ARCore by Google</a> and <a href="#sceneform" target="_blank" rel="noopener noreferrer">Sceneform SDK</a> with the <a href="https://www.unity.com/" target="_blank" rel="noopener noreferrer">Unity Game Engine</a>. 3D models were created in Maya then imported into Android Studio as .obj files to use with Sceneform. Other features are created with native Java for Android.<br/> Watch a video demonstration <a href="https://youtu.be/edLWL6yi7vQ" target="_blank" rel="noopener noreferrer">here</a>.',
    imageUrl: JourEtNuitImage,
    // ✅ Has two standard links
    links: [
      {
        url: "https://nikunami.itch.io/jour-et-nuit",
        text: "Live Demo",
      },
      {
        url: "https://github.com/curtism99/Jour-et-Nuit",
        text: "Source Code",
      },
    ],
  },
  {
    title: "Sprinkler Lube 1200 Promotional Video",
    description:
      "This video was created to promote the Sprinkler Lube 1200 product. It showcases the product's features and benefits as well as visuals of the product in action. The video was created using software such as Final Cut Pro, Motion, and Photoshop.",
    imageUrl: SprinkerLubeImage,
    // ✅ Has two standard links
    links: [
      {
        url: "https://www.youtube.com/watch?v=UeYAKHWCWGs",
        text: "YouTube Video",
      },
    ],
  },
];

const ProjectCard = ({
  title,
  description,
  imageUrl,
  imageAlt,
  imageClassName = "",
  links,
}) => (
  <div className="project-card">
    <img
      src={imageUrl}
      alt={imageAlt || `Screenshot of the ${title} project`}
      className={`project-image ${imageClassName}`.trim()}
      loading="lazy"
      decoding="async"
    />
    <div className="project-info">
      <h3 className="project-title">{title}</h3>
      <p
        className="project-description"
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {/* --- THIS IS THE CRUCIAL DYNAMIC LINK SECTION --- */}
      {links && links.length > 0 && (
        <div className="project-links">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              {link.text} {/* <-- This uses your custom text */}
            </a>
          ))}
        </div>
      )}
      {/* --- END OF THE DYNAMIC LINK SECTION --- */}
    </div>
  </div>
);

function Projects() {
  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="section-title">Other Projects</h2>
        <p className="projects-intro">
          Most of my professional work consists of proprietary projects.
          However, here are a few other personal projects I've built over the
          years that showcase some of my skills.
        </p>
        <div className="project-grid">
          {projectData.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
